import { Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import Modal from "../../../../components/molecures/Modals/Modal";
import useModals from "../../../../hooks/useModals";
import useUser from "../../../../hooks/useUsers";
import { OrderMemo } from "../../../../model/OrderMemo";
import { HttpError } from "../../../../network/types";
import {
  autoOasisCodeString,
  speedMateCodeString,
} from "../../../../routes/constants/path";
import sharedConstants from "../../../../shared/constants";
import { alertError, changeIsoToKorDate } from "../../../../shared/utils";
import { theme } from "../../../../theme";
import { autoOasisLogin, speedMateLogin } from "../../../../apis/Login/apis";
import { StyledModalContainer } from "../../../ReservationConfig/styles";
import {
  fetchOrderMemo,
  sfetchOrderMemo,
} from "../../../../apis/ReservationDetail/apis";

interface Props {
  id: number;
}
const CsMemoModal: React.FC<Props> = ({ id }) => {
  const location = useLocation();
  const specialCode: string | undefined =
    location.search?.includes(speedMateCodeString) ||
    location.search?.includes(autoOasisCodeString)
      ? location
        ? location?.search
            ?.split("&")
            ?.find(
              (text) =>
                text.includes(speedMateCodeString) ||
                text.includes(autoOasisCodeString)
            )
            ?.split("=")[1]
        : undefined
      : undefined;
  const { signIn, signOut } = useUser();
  const singInSpeedMateMutation = useMutation(speedMateLogin, {
    onSuccess: (res) => {
      if (res.accessToken) {
        signIn(res.admin, res.accessToken);
      }
      window.location.reload();
    },
    onError: () => {},
  });
  const singInAutoOasisMutation = useMutation(autoOasisLogin, {
    onSuccess: (res) => {
      if (res.accessToken) {
        signIn(res.admin, res.accessToken);
      }
      window.location.reload();
    },
    onError: () => {},
  });
  const fetchOrderMemoMutation = useMutation(
    specialCode ? sfetchOrderMemo : fetchOrderMemo,
    {
      onSuccess: (res) => {
        setDataForm(res);
      },
      onError: (err: HttpError) => {
        if ((err.status === 401 || err.status === 403) && specialCode) {
          signOut();
          if (location.search?.includes(speedMateCodeString))
            singInSpeedMateMutation.mutate({ repairShopCode: specialCode });
          if (location.search?.includes(autoOasisCodeString))
            singInAutoOasisMutation.mutate({ autooasisCode: specialCode });
        }
        alertError(err.message);
      },
    }
  );

  const { closeModal } = useModals();
  const [dataForm, setDataForm] = useState<OrderMemo>({
    createdAt: "",
    repairShopViewable: true,
    orderMemo: "",
    orderItemNo: "",
    orderNo: "",
    id,
    manager: "",
  });
  useEffect(() => {
    fetchOrderMemoMutation.mutate(id);
  }, [id]);
  return (
    <Modal
      title="고객센터 메모 상세"
      isOneBtn
      onOk={closeModal}
      width={700}
      okButtonProps={{ ghost: true, type: "default" }}
      okText="닫기"
    >
      <StyledModalContainer>
        <Row gutter={[0, 24]}>
          <OneRow>
            <TitleCol>작성일시</TitleCol>
            <ContentCol>
              {dataForm.createdAt
                ? changeIsoToKorDate(
                    dataForm.createdAt,
                    sharedConstants.date.formatYMDHMS
                  )
                : "-"}
            </ContentCol>
          </OneRow>
          <OneRow>
            <TitleCol>메모 내용</TitleCol>
            <ContentCol>
              <TextAreaCol>{dataForm.orderMemo}</TextAreaCol>
            </ContentCol>
          </OneRow>
        </Row>
      </StyledModalContainer>
    </Modal>
  );
};
export default CsMemoModal;
const TitleCol: React.FC = ({ children }) => (
  <StyledTitleCol flex="0 0 165px">{children}</StyledTitleCol>
);
const ContentCol: React.FC = ({ children }) => (
  <Col flex="1 1 0">{children}</Col>
);
const OneRow: React.FC = ({ children }) => (
  <Col span={24}>
    <Row>{children}</Row>
  </Col>
);

const StyledTitleCol = styled(Col)`
  ${theme.typo.heading.b16};
`;
const TextAreaCol: React.FC = ({ children }) => (
  <Col flex="1 1 0" style={{ whiteSpace: "pre" }}>
    {children}
  </Col>
);
